import { Row, Col, Input, Select, Button, Space } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { getProveedoresPO } from "../../../../services/financiero/ingresosPO/proveedoresPOService";
import { getEstadosPO } from "../../../../services/financiero/ingresosPO/ordenesServicioPOService";
import ExportOrdenesServicioPOButton from "./ExportOrdenesServicioPOButton";
const { Option } = Select;

const estadoMap = {
  "FINALLY CLOSED": "Entregado",
  "CLOSED": "Cerrado",
  "CLOSED FOR RECEIVING": "Cerrado para recepción",
  "OPEN": "Pendiente",
  "PENDING": "Pendiente"
};

export default function OrdenesServicioPOFilters({ onFilter, filteredProductos, permissionExport }) {

  const [proveedores, setProveedores] = useState([]);
  const [estados, setEstados] = useState([]);

  const [filters, setFilters] = useState({
    search: "",
    po: "",
    proveedor: null,
    estado: null,
  });

  useEffect(() => {
    cargarCatalogos();
  }, []);

  const cargarCatalogos = async () => {
    try {
      const prov = await getProveedoresPO();
      const est = await getEstadosPO();
      setProveedores(prov);
      setEstados(est);
    } catch (error) {
      console.error("Error cargando filtros");
    }
  };

  const handleChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilter?.(newFilters);
  };

  const limpiarFiltros = () => {
    const empty = { search: "", po: "", proveedor: null, estado: null };
    setFilters(empty);
    onFilter?.(empty);
  };

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 20 }}>
      <Col xs={24} md={6}>
        <Input allowClear placeholder="Buscar producto" prefix={<SearchOutlined />} value={filters.search} onChange={(e) => handleChange("search", e.target.value)} />
      </Col>
      <Col xs={24} md={4}>
        <Input allowClear placeholder="Número PO" value={filters.po} onChange={(e) => handleChange("po", e.target.value)} />
      </Col>
      <Col xs={24} md={5}>
        <Select allowClear placeholder="Proveedor" style={{ width: "100%" }} value={filters.proveedor} onChange={(value) => handleChange("proveedor", value)}>
          {proveedores.map((p) => (
            <Option key={p.oid} value={p.oid}>{p.nombre}</Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} md={4}>
        <Select allowClear placeholder="Estado" style={{ width: "100%" }} value={filters.estado} onChange={(value) => handleChange("estado", value)}>
          {estados.map((e) => {
            const estadoVisual = estadoMap[e.estado] || e.estado;
            return <Option key={e.oid} value={e.oid}>{estadoVisual}</Option>;
          })}
        </Select>
      </Col>
      <Col xs={24} md={1}>
        <Space>
          <Button icon={<ClearOutlined />} onClick={limpiarFiltros} />
        </Space>
      </Col>
      {permissionExport && (
        <div style={{ marginBottom: 16 }}>
          <ExportOrdenesServicioPOButton data={filteredProductos} />
        </div>
      )}
    </Row>
  );
}
